import { Component, EventEmitter, Input, Output, ViewEncapsulation, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormioCustomComponent } from 'dp-formio';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-html-editor-wrapper',
    templateUrl: './html-editor-wrapper.component.html',
    // styleUrls: ['./html-editor-wrapper.component.scss']
    encapsulation: ViewEncapsulation.None
})
export class HtmlEditorWrapperComponent implements FormioCustomComponent<any>, OnDestroy, OnChanges {
    dir: 'rtl' | 'ltr';
    @Input() required: boolean;
    @Input() value: any = {};
    @Output() valueChange = new EventEmitter<any>();
    @Input() disabled: boolean;
    @Input() viewOnly: boolean;
    @Input() data: any;
    @Input() customOptions: any;
    @Input() formioComponent: any;
    private subs: Subscription[] = [];
    set sub(s: Subscription) { this.subs.push(s); }
    model = '';
    multipleModel: Array<{ value: string }> = [];

    constructor(private translateService: TranslateService) {
        this.changeDirection(this.translateService.currentLang);
        this.sub = this.translateService.onLangChange.subscribe(data => {
            this.changeDirection(data.lang);
        });
    }
    ngOnChanges(changes: SimpleChanges) {
        if (this.customOptions) {
            if (this.customOptions.isMultiple) {
                this.multipleModel = this.value?.values?.map(q => { return { value: q } });
                if (!this.multipleModel?.length) this.multipleModel = [{ value: '' }];
            } else if (this.value) {
                this.model = this.value;
            }
        }
    }


    notifyValue() {
        if (this.customOptions.isMultiple) {
            const notEmpty = this.multipleModel
                .filter(q => !!q.value)
                .map(q => q.value);
            if (this.required && (!this.multipleModel.length || notEmpty.length != this.multipleModel.length)) {
                this.value = null;
                this.valueChange.emit(this.value);
                return;
            }
            this.value = { values: notEmpty };
        } else {
            if (this.required && !this.model?.trim()?.length) {
                this.value = null;
                this.valueChange.emit(this.value);
                return;
            }
            this.value = this.model;
        }

        this.valueChange.emit(this.value);
    }

    onTextChange(event: any, index: number = null) {
        if (this.customOptions.isMultiple) {
            this.multipleModel[index].value = event.htmlValue;
        } else {
            this.model = event.htmlValue;
        }
        this.notifyValue();
    }
    addRow() {
        this.multipleModel.push({ value: '' });
    }
    deleteRow(index: number) {
        this.multipleModel.splice(index, 1);
        this.notifyValue();
    }
    private changeDirection(lang) {
        this.dir = null;
        setTimeout(() => { this.dir = lang === 'ar' ? 'rtl' : 'ltr'; });
    }
    ngOnDestroy() {
        this.subs.forEach(s => s.unsubscribe());
        this.subs = [];
    }

}
